/** pt-BR formatting for the admin (BRL, numbers, relative times). */
const nf = new Intl.NumberFormat("pt-BR");
const brl = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
const pct1 = new Intl.NumberFormat("pt-BR", { style: "percent", maximumFractionDigits: 1 });

export const fmtInt = (n: number) => nf.format(n);
export const fmtBRL = (cents: number) => brl.format(cents / 100);
export const fmtPct = (r: number | null | undefined) => (r === null || r === undefined ? "—" : pct1.format(r));

/** R$ 512,8 mil / R$ 1,2 mi for KPI tiles. */
export function fmtBRLCompact(cents: number) {
  const v = cents / 100;
  if (v >= 1_000_000) return `R$ ${(v / 1_000_000).toLocaleString("pt-BR", { maximumFractionDigits: 1 })} mi`;
  if (v >= 10_000) return `R$ ${(v / 1000).toLocaleString("pt-BR", { maximumFractionDigits: 1 })} mil`;
  return brl.format(v);
}

let displayTimeZone: string | undefined;
/**
 * The IANA zone every date and time is shown in: the selected city's (CityProvider sets it before
 * the screens render). `undefined` means the browser's zone.
 */
export function setDisplayTimeZone(tz: string | undefined) {
  displayTimeZone = tz;
}
export const displayTz = () => displayTimeZone;

export const fmtTime = (iso: string) => new Date(iso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", timeZone: displayTimeZone });
export const fmtDate = (iso: string) => new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "short", timeZone: displayTimeZone });
export const fmtDateTime = (iso: string) => `${fmtDate(iso)}, ${fmtTime(iso)}`;
export const fmtDay = (d = new Date()) => d.toLocaleDateString("pt-BR", { weekday: "long", day: "numeric", month: "short", timeZone: displayTimeZone });
export const weekdayName = (d = new Date()) => d.toLocaleDateString("pt-BR", { weekday: "long", timeZone: displayTimeZone }).replace("-feira", "");

/** "há 26 h", "há 7 min", "agora". */
export function ago(iso: string | number | null | undefined, now = Date.now()) {
  if (iso === null || iso === undefined) return "—";
  const s = Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000));
  if (s < 10) return "agora";
  if (s < 60) return `há ${s} s`;
  if (s < 3600) return `há ${Math.round(s / 60)} min`;
  if (s < 86400 * 2) return `há ${Math.round(s / 3600)} h`;
  return `há ${Math.round(s / 86400)} dias`;
}

/** Relative change; null when there is no baseline. */
export function delta(today: number, lastWeek: number | null) {
  if (lastWeek === null || lastWeek === 0) return null;
  return (today - lastWeek) / lastWeek;
}

export const CATEGORY_LABEL: Record<string, string> = { moto: "Moto", go: "Go", conforto: "Conforto", black: "Black", envios: "Envios" };
